<template>
    <div>
        <bulk-revamp-awareness class="mt-5 mx-8" wrap_early />

        <div class="container">
            <div
                class="img_container"
            >
                <img
                    src="@/assets/redchirp-logo-square-center.png"
                    alt="RedChirp logo"
                    class="img"
                />
                let's connect!
            </div>
        </div>
    </div>
</template>

<script>
import BulkRevampAwareness from '@/components/bulk/bulk-revamp-awareness.vue';

export default {
    components: {
        BulkRevampAwareness
    },

    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
.container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
    text-align: center
}

.img_container {
    display: inline-block;
    width: 35%;
    margin: 0 auto;

    font-family: Roboto, "Helvetica Neue", sans-serif, NotoColorEmoji, "apple color emoji", "windows emoji", "windows symbol";
    font-size: 18px;
    font-weight: 700;
    color: #5d647c;
}

.img {
    max-width: 100%;
    max-height: 100%;
    opacity: 0.25;
}
</style>